var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import ConfirmationPage, { StyledConfirmationHeader, StyledConfirmationText, } from "components/mobile_pay/views/confirmation_page";
var StyledCheckNumber = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
export default function CheckPaidPage(_a) {
    var merchantInfo = _a.merchantInfo, checkInfo = _a.checkInfo;
    return (React.createElement(ConfirmationPage, { merchantInfo: merchantInfo },
        React.createElement(StyledConfirmationHeader, null, "You're all set!"),
        React.createElement(StyledConfirmationText, null,
            "Check #",
            React.createElement(StyledCheckNumber, null, checkInfo.checkNumber),
            " ",
            "has already been paid, so you can leave when you're ready.")));
}
var templateObject_1;
